import {Component, Input, OnInit} from '@angular/core';
import {ReportFilter} from '../../../models/dealers/dealer-filter.model';
import {HttpService} from '../../../services/http.service';
import {DealerData} from '../../../models/Report/dealerData.modal';
import {FailedUploadData} from '../../../models/Report/failedUploadData.modal';
import FileSaver from 'file-saver';
import {FailedUploadItem} from '../../../models/Report/failedUploadItem.modal';


@Component({
  selector: 'app-failed-upload-export',
  templateUrl: './failed-upload-export.component.html',
  styleUrls: ['./failed-upload-export.component.scss']
})
export class FailedUploadExportComponent implements OnInit {
  filter: ReportFilter = new ReportFilter();
  failedUploadItems: FailedUploadItem[] = [];
  failedUploadData: FailedUploadData = new FailedUploadData();
  total = 0;
  blob: string;
  count: any;

  constructor(private http: HttpService) {
  }

  ngOnInit(): void {
    this.refreshList();
  }

  orderBy(field: string) {
    if (this.filter.orderBy === field) {
      if (this.filter.order === 'ASC') {
        this.filter.order = 'DESC';
      } else {
        this.filter.order = 'ASC';
      }
    }
    this.filter.orderBy = field;
    this.refreshList();
  }

  refreshList() {
    this.http.getFailedUploadReportItems(this.filter).subscribe((res: FailedUploadData) => {
      this.failedUploadData = Object.assign(new FailedUploadData(), res);
    });
  }
  exportFailedExportAsXLSX(createdDate: string) {
    const payload = this.failedUploadData.dataList.filter(item => {
      return item.createddate.includes(createdDate);
    });
    const data = {
      exportDate: payload[0].createddate
    };
    this.http.downloadFailedExportReport(data, createdDate);
  }
  showDirectionImage(): string {
    if (this.filter.orderBy === 'ASC') {
      return 'assets/images/icon-sort-up.png';
    } else {
      return 'assets/images/icon-sort-down.png';
    }
  }

  clearFilter() {
    this.filter = new ReportFilter();
    this.refreshList();
  }

  changePage(count: number) {
    this.filter.page += count;
    this.refreshList();
  }
}
